import ExecutaRest from '../util/ExecutaRest'

class atendimentoApi {
    static ObterAtendimentosCidadao(parametros) {


        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {
            
            rest.Post('AtendimentoSL.svc/rest/ObterAtendimentosCidadaoREST', parametros).then(retorno => {
                
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> ObterMensagemPorProtocoloSenha: ' + error /*areaTratamento.statusText*/);
            });

        });

    }

}

 export default atendimentoApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/atendimentoApi.js
 **/